import {
  Button,
  Container,
  Group,
  Loader,
  Modal,
  // NumberInput,
  Select,
  Switch,
  Table,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { showNotification, updateNotification } from "@mantine/notifications";
import { useEffect, useState } from "react";
import { fetchDomainsApi } from "../api/general";
import {
  allowTaskSubmissionApi,
  disallowTaskSubmissionApi,
  inductMenteeApi,
  // eliminateMenteeApi,
  handleMembersApi,
  updateMentorApi,
  // updateShowResultApi,
  fetchMentorMenteesCount,
} from "../api/missionControl";
import { makeAdminApi } from "../api/settings";

async function fetchDomains() {
  try {
    const res = await fetchDomainsApi().catch((err) => {
      showNotification({
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        localStorage.clear();
        window.location.replace("/");
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else {
      showNotification({
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: "Fetch domains",
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function fetchMMCount() {
  try {
    const res = await fetchMentorMenteesCount().catch((err) => {
      showNotification({
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        localStorage.clear();
        window.location.replace("/");
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else {
      showNotification({
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: "Fetch Mentor Mentees Count",
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function updateMentorFunc(data, notid) {
  try {
    const res = await updateMentorApi(data).catch((err) => {
      updateNotification({
        id: notid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      console.log(res);
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (e) {
    updateNotification({
      id: "Update mentor",
      title: "ERROR",
      message: e.response.data.message,
      color: "red",
    });
  }
}

// async function updateShowResult(data, notid) {
//   try {
//     const res = await updateShowResultApi(data).catch((err) => {
//       updateNotification({
//         id: notid,
//         title: "ERROR",
//         message:
//           err.response != null
//             ? err.response.data != null
//               ? err.response.data.message != null
//                 ? err.response.data.message
//                 : err.message
//               : err.message
//             : err.message,
//         color: "red",
//       });
//       if (err.response.status == 401 || err.response.status == 403) {
//         if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
//           localStorage.clear();
//           window.location.replace("/");}
//       }
//       return [];
//     });
//     if (res.status == 200) {
//       return res.data;
//     } else if (res.status == 401 || res.status == 403) {
//       updateNotification({
//         id: notid,
//         title: "ERROR",
//         message: res.data.message,
//         color: "red",
//       });
//       if (res.data.message !== "Invalid pin") {
//         localStorage.clear();
//         window.location.replace("/");
//       }
//     } else {
//       updateNotification({
//         id: notid,
//         title: "ERROR",
//         message: res.data.message,
//         color: "red",
//       });
//       return [];
//     }
//   } catch (error) {
//     updateNotification({
//       id: "Update show result",
//       title: "ERROR",
//       message: error.response.data.message,
//       color: "red",
//     });
//   }
// }

async function allowSubmission(data, notid) {
  try {
    const res = await allowTaskSubmissionApi(data).catch((err) => {
      updateNotification({
        id: notid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
          localStorage.clear();
          window.location.replace("/");}
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: notid,
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function disallowSubmission(data, notid) {
  try {
    const res = await disallowTaskSubmissionApi(data).catch((err) => {
      updateNotification({
        id: notid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if( err.response.data.message=="No token"||err.response.data.message=="Invalid token or Token expired" || err.response.data.message== "Token expired"){
          localStorage.clear();
          window.location.replace("/");}
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    //console.log(error);
  }
}

// async function eliminateMentee(data, notid) {
//   try {
//     const res = await eliminateMenteeApi(data).catch((err) => {
//       updateNotification({
//         id: notid,
//         title: "ERROR",
//         message:
//           err.response != null
//             ? err.response.data != null
//               ? err.response.data.message != null
//                 ? err.response.data.message
//                 : err.message
//               : err.message
//             : err.message,
//         color: "red",
//       });
//       if(err.response.status == 401 || err.response.status == 403) {
//         localStorage.clear();
//         window.location.replace("/");
//       }
//       return [];
//     });
//     if (res.status == 200) {
//       return res.data;
//     } else if (res.status == 401 || res.status == 403) {
//         updateNotification({
//           id: notid,
//           title: "ERROR",
//           message: res.data.message ,
//           color: "red",
//         });
//         localStorage.clear();
//         window.location.replace("/");
//     }  else {
//       updateNotification({
//         id: notid,
//         title: "ERROR",
//         message: res.data.message,
//         color: "red",
//       });
//       return [];
//     }
//   } catch (error) {
//     console.log(error);
//   }
// }

//Induct Mentees

async function inductMentee(data, notid) {
  try {
    const res = await inductMenteeApi(data).catch((err) => {
      updateNotification({
        id: notid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.response.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: notid,
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

async function uploadMember(data, notid) {
  try {
    const res = await handleMembersApi(data).catch((err) => {
      updateNotification({
        id: notid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    //console.log(error);
  }
}

async function makeAdminFunc(data, notificationid) {
  try {
    const res = await makeAdminApi(data).catch((err) => {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message:
          err.response != null
            ? err.response.data != null
              ? err.response.data.message != null
                ? err.response.data.message
                : err.message
              : err.message
            : err.message,
        color: "red",
      });
      if (err.response.status == 401 || err.response.status == 403) {
        if (err.data.message !== "Invalid pin") {
          localStorage.clear();
          window.location.replace("/");
        }
      }
      return [];
    });
    if (res.status == 200) {
      return res.data;
    } else if (res.status == 401 || res.status == 403) {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      if (res.data.message !== "Invalid pin") {
        localStorage.clear();
        window.location.replace("/");
      }
    } else {
      updateNotification({
        id: notificationid,
        title: "ERROR",
        message: res.data.message,
        color: "red",
      });
      return [];
    }
  } catch (error) {
    updateNotification({
      id: "Make Admin",
      title: "ERROR",
      message: error.response.data.message,
      color: "red",
    });
  }
}

export const dropzoneChildren = (status) => (
  <Group
    position="center"
    spacing="xl"
    style={{
      pointerEvents: "none",
      border: "1px solid " + status.accepted ? "green" : "red",
    }}
  >
    <div>
      <Text size="l" inline>
        Drag CSV file here or click to select file
      </Text>
    </div>
  </Group>
);

export default function MissionControl() {
  const [domains, setDomains] = useState([]);
  const [mentorMenteeCount, setMentorMenteeCount] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [changeMentor, setChangeMentor] = useState({
    menteeRoll: "",
    mentorRoll: "",
    domainId: null,
  });
  // const [eliminatingMentee, setEliminatingMentee] = useState("");
  // const [domain, setDomain] = useState("");
  // const [taskElNum, setTaskElNum] = useState();
  const [InductingMentee, setInductingMentee] = useState("");
  const [domain, setDomain] = useState("");
  // const [taskInduct, setTaskInduct] = useState();
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [newAdmin, setNewAdmin] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [adminKey, setadminKey] = useState("");
  // const [func, setFunc] = useState();
  const [functionParams, setFunctionParams] = useState();
  const [functionType, setFunctionType] = useState("");

  const updateTasks = (id, result) => {
    let tempTask = tasks;
    for (let idx in tempTask) {
      if (tempTask[idx].id == id) {
        if (result) {
          tempTask[idx].showResult = !tempTask[idx].showResult;
        } else {
          tempTask[idx].subAllowed = !tempTask[idx].subAllowed;
        }
        break;
      }
    }
    setTasks([...tempTask]);
  };

  useEffect(() => {
    fetchDomains().then((response) => {
      setDomains(
        response.domains.map((data) => {
          return { value: data.id, label: data.name };
        })
      );
      let tempTask = [];
      response.domains.forEach((domain) => {
        domain.Tasks.forEach((task) => {
          tempTask.push({
            ...task,
            domainId: domain.id,
            domainName: domain.name,
          });
        });
        fetchMMCount().then((response) => {
          setMentorMenteeCount(response);
          setTasks([...tempTask]);
          setLoading(false);
        });
      });
    });
  }, []);

  const updateMentor = () => {
    showNotification({
      id: "updatementor",
      title: "Updating Mentor",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    updateMentorFunc(
      {
        ...changeMentor,
        adminPin: adminKey,
      },
      "updatementor"
    )
      .then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          setChangeMentor({
            menteeRoll: null,
            mentorRoll: null,
            domainId: null,
          });
          setadminKey("");
          updateNotification({
            id: "updatementor",
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
        }
      })
      .catch(() => {
        setadminKey("");
      });
  };

  const handleTaskOpenSwitch = (event, id) => {
    if (event.currentTarget.checked) {
      showNotification({
        id: "opening" + id,
        title: "Opening Portal for " + id,
        loading: true,
        autoClose: false,
        disallowClose: true,
      });
      //open portal
      allowSubmission({ taskId: id }, "opening" + id).then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          updateTasks(id);
          updateNotification({
            id: "opening" + id,
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
        }
      });
    } else {
      showNotification({
        id: "closing" + id,
        title: "Closing Portal for " + id,
        loading: true,
        autoClose: false,
        disallowClose: true,
      });
      disallowSubmission({ taskId: id }, "closing" + id).then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          updateTasks(id);
          updateNotification({
            id: "closing" + id,
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
        }
      });
    }
  };

  // const handleTaskResultSwitch = (event, id) => {
  //   if (!event.currentTarget.checked) {
  //     showNotification({
  //       title: "Cannot Switch off task show result once shown",
  //       color: "red",
  //     });
  //     return;
  //   }
  //   showNotification({
  //     id: "show" + id,
  //     title: "Switching Task state for " + id,
  //     loading: true,
  //     autoClose: false,
  //     disallowClose: true,
  //   });
  //   updateShowResult({ taskId: id }, "show" + id).then((res) => {
  //     if (typeof res !== "undefined" && Object.keys(res).length) {
  //       updateTasks(id, "result");
  //       updateNotification({
  //         id: "show" + id,
  //         title: "SUCCESS",
  //         message: res.message,
  //         color: "green",
  //       });
  //     }
  //   });
  // };

  // const eliminate = () => {
  //   showNotification({
  //     id: "eliminate",
  //     title: "Eliminating",
  //     loading: true,
  //     autoClose: false,
  //     disallowClose: true,
  //   });
  //   if(!taskElNum && !eliminatingMentee && !domain) {
  //     updateNotification({
  //       id: "eliminate",
  //       title: "Fill the fields",
  //       color: "red"
  //     });
  //     return;
  //   }
  //   eliminateMentee(
  //     {
  //       rejRound: taskElNum,
  //       menteeRoll: eliminatingMentee,
  //       domainId: domain,
  //     },
  //     "eliminate"
  //   ).then((res) => {
  //     if(typeof res !== "undefined" && Object.keys(res).length) {
  //       setEliminatingMentee("");
  //       setDomain("");
  //       updateNotification({
  //         id: "eliminate",
  //         title: "SUCCESS",
  //         message: res.message,
  //         color: "green",
  //       });
  //     } else  {
  //       updateNotification({
  //         id: "eliminate",
  //         message: "Some Error Occured",
  //         color: "red",
  //       });
  //     }
  //   });
  // };

  //Induct
  const induct = () => {
    showNotification({
      id: "induct",
      title: "Inducting",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    if (!InductingMentee && !domain) {
      updateNotification({
        id: "induct",
        title: "Fill the fields",
        color: "red",
      });
      return;
    }
    inductMentee(
      {
        menteeRoll: InductingMentee,
        domainId: domain,
        adminPin: adminKey,
      },
      "induct"
    )
      .then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          setInductingMentee("");
          setDomain("");
          setadminKey("");
          updateNotification({
            id: "induct",
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
        }
      })
      .catch(() => {
        setadminKey("");
      });
  };

  const makeAdmin = () => {
    showNotification({
      id: "add-admin",
      title: "Adding Admin",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    makeAdminFunc({ roll: newAdmin, adminPin: adminKey }, "add-admin")
      .then((res) => {
        if (typeof res !== "undefined" && Object.keys(res).length) {
          updateNotification({
            id: "add-admin",
            title: "SUCCESS",
            message: res.message,
            color: "green",
          });
          setNewAdmin("");
          setadminKey("");
        }
      })
      .catch(() => {
        setadminKey("");
      });
  };

  const uploadFile = (files) => {
    setUploading(true);
    // const formData = new FormData();
    // formData.append("members", files[0]);
    const fileData = files[0];
    showNotification({
      id: "memberupload",
      title: "Uploading csv file",
      loading: true,
      autoClose: false,
      disallowClose: true,
    });
    uploadMember(
      {
        members: fileData,
        adminPin: adminKey,
      },
      "memberupload"
    )
      .then((res) => {
        if (Object.keys(res).length) {
          updateNotification({
            id: "memberupload",
            title: "SUCCESS",
            message: "File uploaded",
            color: "teal",
          });
          setUploading(false);
          setadminKey("");
          setModalOpen(false)
        }
        return res;
      })
      .catch((e) => {
        setUploading(false);
        updateNotification({
          id: "memberupload",
          message: e.response.data.message,
          color: "red",
        });
        setadminKey("");
      });
  };

  const modalHandler = () => {
    switch (functionType) {
      case "updateMentor":
        updateMentor();
        break;
      case "induct":
        induct();
        break;
      case "admin":
        makeAdmin();
        break;
      case "upload":
        uploadFile(functionParams);
        break;
    }
  };

  // const modalFun = (functiontopass) => {
  //   setFunc(() => functiontopass);
  //   setModalOpen(true);
  // }

  return (
    <Container>
      <Title order={1}>Mission Control</Title>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Modal
            opened={modalOpen}
            onClose={() => setModalOpen(false)}
            title="Enter Admin Pin"
          >
            <TextInput
              placeholder="Enter Admin Key To Continue"
              value={adminKey}
              onChange={(event) => {
                setadminKey(event.currentTarget.value);
              }}
            />
            <br></br>
            <Button
              style={{ width: 100, float: "right" }}
              onClick={modalHandler}
            >
              Submit
            </Button>
          </Modal>
          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Change the Mentor of a Mentee</Title>
            <br></br>
            <Container
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
                padding: 0,
              }}
            >
              <TextInput
                type="number"
                style={{ width: "48%" }}
                placeholder="Mentee"
                label="Mentee's Roll No."
                value={changeMentor.menteeRoll}
                onChange={(event) => {
                  let val = event.currentTarget.value.replace(/\D/g, "");
                  setChangeMentor({ ...changeMentor, menteeRoll: val });
                }}
              />
              <TextInput
                type="number"
                style={{ width: "48%" }}
                placeholder="Mentor"
                label="Mentor's Roll No."
                value={changeMentor.mentorRoll}
                onChange={(event) => {
                  let val = event.currentTarget.value.replace(/\D/g, "");
                  setChangeMentor({ ...changeMentor, mentorRoll: val });
                }}
              />
            </Container>
            <br></br>
            <Select
              placeholder="Select Domain"
              label="Select Domain"
              value={changeMentor.domainId}
              onChange={(val) =>
                setChangeMentor({ ...changeMentor, domainId: val })
              }
              data={domains}
            />
            <br></br>
            <Button
              onClick={() => {
                setFunctionType("updateMentor");
                setModalOpen(true);
              }}
            >
              Update Mentor
            </Button>
          </Container>
          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Open/Close Task Portal</Title>
            <br></br>
            <Table>
              <thead>
                <tr style={{ backgroundColor: "#228be6" }}>
                  <th style={{ color: "white" }}>Domain</th>
                  <th style={{ color: "white" }}>Task no.</th>
                  <th style={{ color: "white" }}>Title</th>
                  <th style={{ color: "white" }}>State</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <tr key={task.id}>
                    <td>{task.domainName}</td>
                    <td>{task.taskNo}</td>
                    <td>{task.title}</td>
                    <td>
                      <Switch
                        onLabel="ON"
                        offLabel="OFF"
                        checked={task.subAllowed}
                        onChange={(event) =>
                          handleTaskOpenSwitch(event, task.id)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container>
          {/* <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Show Result of a Task</Title>
            <br></br>
            <Table>
              <thead>
                <tr style={{ backgroundColor: "#228be6" }}>
                  <th style={{ color: "white" }}>Domain</th>
                  <th style={{ color: "white" }}>Task no.</th>
                  <th style={{ color: "white" }}>Title</th>
                  <th style={{ color: "white" }}>State</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <tr key={task.id}>
                    <td>{task.domainName}</td>
                    <td>{task.taskNo}</td>
                    <td>{task.title}</td>
                    <td>
                      <Switch
                        onLabel="ON"
                        offLabel="OFF"
                        checked={task.showResult}
                        onChange={(event) =>
                          handleTaskResultSwitch(event, task.id)
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container> */}
          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
              textAlign: "center",
            }}
          >
            <Title order={6}>Mentor And Mentees in each Domain</Title>
            <br></br>
            <Table>
              <thead>
                <tr style={{ backgroundColor: "#228be6" }}>
                  <th style={{ color: "white", textAlign: "center" }}>
                    Domain
                  </th>
                  <th style={{ color: "white", textAlign: "center" }}>
                    Mentors
                  </th>
                  <th style={{ color: "white", textAlign: "center" }}>
                    Mentees
                  </th>
                </tr>
              </thead>
              <tbody>
                {mentorMenteeCount.map((obj) => (
                  <tr key={obj.domainId}>
                    <td>
                      {domains.find((d) => d.value === obj.domainId).label}
                    </td>
                    <td>{obj.mentorsCount}</td>
                    <td>{obj.menteesCount}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Container>
          {/* <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Eliminate Mentees</Title>
            <br></br>
            <TextInput
              type="number"
              style={{ minWidth: "50%" }}
              placeholder="Mentee"
              label="Mentee's Roll No."
              value={eliminatingMentee}
              onChange={(event) => {
                let val = event.currentTarget.value.replace(/\D/g, "");
                setEliminatingMentee(val);
              }}
            />
            <br></br>
            <Select
              placeholder="Select Domain"
              label="Select Domain"
              value={domain}
              onChange={setDomain}
              data={domains}
            />
            <br></br>
            <NumberInput
              placeholder="Task No."
              label="Task No."
              value={taskElNum}
              onChange={(val) => setTaskElNum(val)}
            />
            <br></br>
            <Button onClick={eliminate}>Eliminate</Button>
          </Container> */}

          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Induct Mentees</Title>
            <br></br>
            <TextInput
              type="number"
              style={{ minWidth: "50%" }}
              placeholder="Mentee"
              label="Mentee's Roll No."
              value={InductingMentee}
              onChange={(event) => {
                let val = event.currentTarget.value.replace(/\D/g, "");
                setInductingMentee(val);
              }}
            />
            <br></br>
            <Select
              placeholder="Select Domain"
              label="Select Domain"
              value={domain}
              onChange={setDomain}
              data={domains}
            />
            <br></br>

            <br></br>
            <Button
              onClick={() => {
                setFunctionType("induct");
                setModalOpen(true);
              }}
            >
              Induct
            </Button>
          </Container>
          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Add a New Admin</Title>
            <br></br>
            <TextInput
              type="number"
              placeholder="Roll Number"
              value={newAdmin}
              onChange={(event) => {
                let val = event.currentTarget.value.replace(/\D/g, "");
                setNewAdmin(val);
              }}
            />
            <br></br>
            <Button
              onClick={() => {
                setFunctionType("admin");
                setModalOpen(true);
              }}
            >
              Make Admin
            </Button>
          </Container>
          <Container
            style={{
              padding: 16,
              margin: 16,
              border: "2px solid #ddd",
              borderRadius: 8,
            }}
          >
            <Title order={6}>Upload Members Csv</Title>
            <br></br>
            <Dropzone
              multiple={false}
              loading={uploading}
              name="members"
              onDrop={(files) => {
                setFunctionType("upload");
                setFunctionParams(files);
                setModalOpen(true);
              }}
              onReject={(files) =>
                setUploading(false) &&
                showNotification({
                  title: "ERROR",
                  message: "File Rejected" + files,
                  color: "red",
                })
              }
              accept={MIME_TYPES.csv}
            >
              {(status) => dropzoneChildren(status)}
            </Dropzone>
            <br></br>
          </Container>
        </>
      )}
    </Container>
  );
}
